// import $public from '../../util/public.js'
export default {
	namespaced: true,
	state: {
		type:'list',
	},
	getters: {
		
	},
	mutations: {
		set_type(state, params) {
			state.type = params;
		},
	},
	actions: {

	},
};
